<template>
    <section id="login">

        <div class="top">
            <img src="../../assets/img/logox.png" alt="">
            <!-- <h2>欢迎使用无源智能锁管理系统</h2> -->
        </div>
        <div class="middle">
            <img src="../../assets/img/a.png" alt="">
        </div>
        <div class="bottom">
            <img src="../../assets/img/logo.png" alt="">
            <h2>版权所有：北京飞利信信息安全技术有限公司</h2>
        </div>

        <div class="login-box">
            <div class="main">
                <h1>无源智能锁管理系统</h1>
                <el-form class="login_form" :model="loginForm" ref="loginForm" :rules="rules">
                    <el-form-item prop="loginName">
                        <el-input v-model.trim="loginForm.loginName">
                            <span class="fa-box" slot="prefix"><i class="fa fa-user"></i></span>
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="loginToken">
                        <el-input v-model.trim="loginForm.loginToken" type="password" @keyup.native.enter="login">
                            <span class="fa-box" slot="prefix"><i class="fa fa-lock"></i></span>
                        </el-input>
                    </el-form-item>
                    <p class="operate">
                        <el-checkbox v-model="checked" class="fl">记住密码</el-checkbox>
                        <el-button type="text" v-model="checked" class="fr" @click="forgetPwd">忘记密码?</el-button>
                    </p>
                    <el-button class="login-btn" type="primary"  @click="login" :loading="loading">登 录</el-button>
                </el-form>
            </div>
            <div class="tips">
                建议使用chrome浏览器/IE11以上
            </div>
        </div>

        <!-- 找回密码 -->
        <el-dialog title="密码找回" :visible.sync="forgetPwdVisible" width="460px" @closed="$refs.fogetPwdForm.resetFields()">
            <el-form :model="fogetPwdForm" label-position="top" label-width="120px" class="fogetPwdForm" ref="fogetPwdForm" :rules="fogetPwdFormRules">
                <el-form-item label="请输入您需要找回的账号：" prop="loginName">
                    <el-input placeholder="请输入用户名" v-model.trim="fogetPwdForm.loginName" class="phone"></el-input>
                    <!-- <el-button type="primary" class="send-code" @click="checkPhone" :loading="sendCodeLoading">验证</el-button> -->
                </el-form-item>
                <el-form-item class="code" prop="code">
                    <el-input placeholder="请输入验证码" v-model.trim="fogetPwdForm.code"></el-input>
                    <div class="code-view">{{this.code}}</div>
                    <el-button type="text" @click="createCode">看不清</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" class="reset" @click="checkPhone" :loading="sendCodeLoading">重置密码</el-button>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button @click="forgetPwdVisible=false">取消</el-button>
            </span>
        </el-dialog>

    </section>
</template>

<script>

export default {
    data() {
        const checkCodeFun = (rule, value, callback) => {
            if (value !== this.code) {
                callback(new Error('验证码不正确'))
            } else {
                callback()
            }
        }
        return {
            loading: false,
            loginForm: {},
            fogetPwdForm: {},
            fogetPwdFormRules: {
                loginName: {required: true, message: '请输入用户名', trigger: 'blur'},
                code: [
                    {required: true, message: '请输入验证码', trigger: 'change'},
                    {validator: checkCodeFun, trigger: 'change'}
                ]
            },
            checked: false,
            code: '',
            phone: null,
            forgetPwdLoading: false,
            forgetPwdVisible: false,
            sendCodeLoading: false,
            rules: {
                loginName: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
                loginToken: [{ required: true, message: '请输入密码', trigger: 'blur' }]
            }
        }
    },
    methods: {
        login() {
            this.$refs.loginForm.validate(valid => {
                if (!valid) return
                this.getToken()
                // this.getLookupList()
            })
        },
        // 图片验证码
        createCode() {
            // 先清空验证码的输入
            let code = ''
            this.code = ''
            // 验证码的长度
            const codeLength = 4
            // 随机数
            const random = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
            for (let i = 0; i < codeLength; i++) {
                // 取得随机数的索引（0~35）
                let index = Math.floor(Math.random() * 36)
                // 根据索引取得随机数加到code上
                code += random[index]
            }
            // 把code值赋给验证码
            this.code = code
        },
        forgetPwd() {
            this.forgetPwdVisible = true
        },
        checkPhone() {
            this.$refs.fogetPwdForm.validate(valid => {
                if (!valid) return
                this.$http('GET', `/principal/exists/${this.fogetPwdForm.loginName}loginName`, {
                    showMsg: true,
                    self: this,
                    loading: 'sendCodeLoading'
                }).then(res => {
                    if (res.data.code === 200) {
                        this.forgetPwdVisible = false
                    }
                })
            })
        },
        // 获取登录信息
        getToken() {
            this.$http('POST', '/principal/login', {
                data: Object.assign(this.loginForm, {
                    authority: 'LG_SYSTEM'
                }),
                showMsg: true,
                self: this,
                loading: 'loading'
            }).then(res => {
                if (res.data.code === 200) {
                    // 调用配置cookie方法,传入账号名，密码，和保存天数3个参数
                    if (this.checked) {
                        this.setCookie(this.loginForm.loginName, this.loginForm.loginToken, 7, this.checked)
                    } else {
                        this.clearCookie()
                    }
                    sessionStorage.setItem('userInfo', JSON.stringify(res.data.content))
                    sessionStorage.setItem('token', res.data.content.token)
                    this.$router.push('/')
                }
            })
        },
        // 拉取数据字典
        getLookupList() {
            this.$http('POST', '/lookupList/list').then(res => {
                if (res.data.code === 200) {
                    let lookupList = res.data.content.map(item => ({
                        key: item.code,
                        lookupName: item.lookupName,
                        lookupValues: item.lookupValues.map(subitem => ({
                            label: subitem.displayValue,
                            value: subitem.code
                        }))
                    }))
                    sessionStorage.setItem('lookupList', JSON.stringify(lookupList))
                }
            })
        },
        // 设置cookie
        setCookie(cName, cPwd, exdays, remeberFlag) {
            var exdate = new Date() // 获取时间
            exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays) // 保存的天数
            // 字符串拼接cookie
            window.document.cookie = 'userName' + '=' + cName + ';path=/;expires=' + exdate.toGMTString()
            window.document.cookie = 'userPwd' + '=' + cPwd + ';path=/;expires=' + exdate.toGMTString()
            window.document.cookie = 'remeberFlag' + '=' + remeberFlag + ';path=/;expires=' + exdate.toGMTString()
        },
        // 读取cookie
        getCookie() {
            if (document.cookie.length > 0) {
                var arr = document.cookie.split('; ')
                for (var i = 0; i < arr.length; i++) {
                    var arr2 = arr[i].split('=') // 再次切割
                    // 判断查找相对应的值
                    if (arr2[0] === 'userName') {
                        this.$set(this.loginForm, 'loginName', arr2[1])
                    } else if (arr2[0] === 'userPwd') {
                        this.$set(this.loginForm, 'loginToken', arr2[1])
                    } else if (arr2[0] === 'remeberFlag') {
                        this.checked = arr2[1] === 'true'
                    }
                }
            }
        },
        // 清除cookie
        clearCookie: function() {
            this.setCookie('', '', -1) // 修改2值都为空，天数为负1天就好了
        },
        submitForgetPwd() {

        }
    },
    created() {
        this.createCode()
    },
    mounted() {
        this.getCookie()
    }
}
</script>

<style lang="scss">
@function pm($px) {
  //$px为需要转换的字号
  @return $px / 16 * 1rem;
}
#login {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    font-family: 'Microsoft YaHei';
    .operate {
        overflow: hidden;
        margin: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .el-checkbox__label {
            font-size: 12px !important;
        }
        .el-button--text {
            font-size: 12px;
        }
    }
    .el-dialog__body {
        padding:20px 20px 0;
    }
    .fogetPwdForm {
        padding: 0 40px;
        .phone {
            .el-input__inner {
                border-top-right-radius: 0 !important;
                border-bottom-right-radius: 0 !important;
            }
        }
        .reset {
            padding: 10px 15px;
        }
        .code .el-form-item__content{
            display: flex;
            align-items: center;
            .el-input {
                flex: 3;
            }
            .code-view {
                position: relative;
                border-radius: 4px;
                flex:1;
                margin: 0 10px;
                height: 36px;
                text-align: center;
                line-height: 36px;
                color: #fff;
                font-family:"Georgia";
                font-size: 12px;
                font-weight: bold;
                letter-spacing: .4em;
                text-shadow : rgba(255, 255, 255, 0.5) 0 5px 6px, rgb(9, 32, 64) 1px 3px 3px;
                cursor: pointer;
                background-color: #409EFF;
                -webkit-user-select:none;
                -moz-user-select:none;
                -ms-user-select:none;
                user-select:none;
            }
        }
    }
    .top {
        flex:3;
        background-color: #fff;
        display: flex;
        align-items: center;
        padding: 0 6%;
        h2 {
            font-size: pm(24);
            color: #333;
            margin-left: 50px;
            font-weight: normal;
        }
        img {
            width: pm(412);
            height: pm(56);
        }
    }
    .middle {
        flex: 18;
        overflow: hidden;
        img {
            width: 100%;
            height: 100%;
        }
    }
    .bottom {
        flex: 3;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        img {
            height: 120px;
        }
        h2 {
            font-size: pm(18);
            font-weight: normal;
            color: #333;
            padding: 0 pm(26);
            margin: 0 pm(26);
            border-left: 1px solid #666;
        }
    }
    .login-box {
        position: absolute;
        top: 50%;
        transform: translateY(-60%);
        text-align: center;
        right: pm(300);
        width: pm(360);
        overflow: hidden;
        border-radius: 4px;
        background-color: #fff;
        .main {
            padding: 0 pm(40);
        }
        h1 {
            font-size: pm(24);
            line-height: pm(40);
            color: #439aff;
            font-weight: normal;
        }
        .tips {
            height: pm(60);
            line-height: pm(60);
            font-size: pm(14);
            color: #999;
            background-color: #fafafa;
        }
        .el-input {
            height: pm(42);
            line-height: pm(42);
            .el-input__prefix {
                left: 1px;
            }
            .fa-box {
                display: block;
                width: pm(42);
                height: calc(100% - 2px);
                margin-top: 1px;
                background-color:#e9eef5;
                color: #79abfc;
                font-size: pm(20);
            }
            .el-input__inner {
                height: pm(42);
                background-color: #f7f7f7;
                padding-left: pm(60);
            }
        }
        .login-forget {
            float:right;
            padding: 0;
            font-size: pm(12);
            color: #439aff;
        }
        .login-btn {
            width: 100%;
            height: pm(38);
            margin: pm(20) 0;
            font-size: pm(14);
            border-radius: 4px;
            letter-spacing: .1em;
        }
    }
}

@media only screen and (max-width: 1366px){
    #login {
        .el-form-item {
            margin-bottom: 16px;
        }
        .el-input {
            img {
                margin-top:5px !important;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Login.vue